
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { getCurrentUser, isAuthenticated, logoutUser } from '@/utils/auth';
import { checkIsAdminFromLocalStorage } from '@/utils/userRoleService';

export const useAdminSettings = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState<any>(null);
  const [activeTab, setActiveTab] = useState("domain");
  
  useEffect(() => {
    if (!isAuthenticated() || !checkIsAdminFromLocalStorage()) {
      navigate('/login');
      return;
    }
    
    const currentUser = getCurrentUser();
    setUser(currentUser);
    setIsLoading(false);
  }, [navigate]);
  
  const handleLogout = async () => {
    try {
      setIsLoading(true);
      await logoutUser();
      toast({
        title: "Logged out",
        description: "You have been successfully logged out."
      });
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Error logging out:', error);
      toast({
        title: "Error",
        description: "Failed to log out. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleSaveSettings = (section: string) => {
    toast({
      title: "Settings Saved",
      description: `${section} settings have been updated successfully.`,
    });
  };
  
  return {
    isLoading,
    activeTab,
    setActiveTab,
    user,
    handleLogout,
    handleSaveSettings
  };
};
